window.addEventListener('load', function () {
  const targets = [
    '.water-bottle-size-prod__lists',
    '.water-bottle-function__lists',
    '.water-bottle-other__lists',
  ];

  const instances = new Map();

  function initSlick() {
    const isSP = window.innerWidth <= 768;

    targets.forEach(function (selector) {
      const $el = $(selector);
      if (!$el.length) return;

      if (isSP && !instances.get(selector)) {
        $el.slick({
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: false,
          speed: 500,
          fade: false,
          swipe: true,
          arrows: false,
          infinite: false,
          lazyLoad: 'progressive',
        });
        instances.set(selector, true);
      } else if (!isSP && instances.get(selector)) {
        $el.slick('unslick');
        instances.set(selector, false);
      }
    });
  }

  initSlick();
  $(window).on('resize', initSlick);
});
